import {apiConfig} from '@stencil/hotels-config';
import Megatron from '@stencil/megatron';

const makeUrl = (tagId, vhid) => {
  return `${apiConfig.__VOYAGERX__}/api/v1/hotels/get_media_data_by_tagids/?voyagerid=${vhid}&tagids=[${tagId}]`;
};

const hotelsGetVoyagerMediaImages = async ({tagId, vhid}) => {
  const url = makeUrl(tagId, vhid);
  return await Megatron({
    name: 'Get Media API',
    type: 'GET',
    credentials: 'same-origin',
    url: url,
  });
};

export default hotelsGetVoyagerMediaImages;
